import Common from '../../Common';
import Item, { UserPbxFlowItem } from '../company/pbxFlow/Item';

export interface UserPbxFlow {
	id: id
	pbx_company_id: id
	name: string
	description?: string
	pbx_did_id?: id
	items: UserPbxFlowItem[]
}

const PbxFlow = class extends Common {
	item: InstanceType<typeof Item>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.item = new Item(headers);
	}

	browse = (userId: id): CustomResponse<UserPbxFlow[]> =>
		this.get(`/user/${userId}/pbxflow`)

	read = (userId: id, id: id): CustomResponse<UserPbxFlow> =>
		this.get(`/user/${userId}/pbxflow/${id}`)
}

export default PbxFlow;
